import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

export default function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="rich-editor">
      <ReactQuill theme="snow" value={value || ''} onChange={onChange} modules={MODULES} placeholder={placeholder} />
      <style>{`.rich-editor .ql-container { min-height: 150px; } .rich-editor .ql-editor { min-height: 150px; }`}</style>
    </div>
  );
}
